<div [id]="id" *ngIf="display" class="row solid-section">
    <div class="col-12 event__donation">
        <div class="row px-0 mx-0">
            <div class="col-12 col-md-6 image left">
                <img [src]="image" class="align-center w-100" alt=""/>
            </div>
            <div class="col-12 col-md-6 right">
                <div>
                    <div class="title" [innerHTML]="title"></div>
                    <app-read-more *ngIf="block.campaignData.desc" 
                    [text]="block.campaignData.desc" 
                    [classes]="descClasses"
                    [textColor]="eventPageConfig.customColorTheme.campaignSectionColors.donationCampaignSectionTextColor"
                    >
                    </app-read-more>
                </div>
                <div class="justify-content-between">
                    <a [href]="url" target="_blank"
                        class="btn btn-lg btn--black modal-pledge-button mb-3 mr-3"
                        [ngClass]="buttonClass"
                        [innerText]="buttonText">
                    </a>
                    @if(showLeaderboardBtn) {
                        <a [href]="leaderboardUrl" target="_blank"
                            class="btn btn-lg btn--black modal-pledge-button mb-3 peer-to-peer-btn">
                            See Leaderboard
                        </a>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
